import React from 'react';
import "./Nav.css";
import requests from "./requests";
// import axios from "./axios";
// import { CompareArrowsOutlined } from '@material-ui/icons';
// import requests from "./requests";

function Nav({ setSelectedOption }) {

    // An attempt at creating a dynamic NAv bar by fetching genres from API

    //    const [genres, setGenres] = useState([]);
    //     const [byIDs, setbyIDs] = useState([]);

    //     useEffect(() => {
    //         async function fetchGenres() {
    //             const request = await axios.get(requests.fetchGenre);

    //             console.log(request);
    //             // console.table(request);
    //             setGenres(request.data.genres);
    //             return request;
    //         } 
    //         fetchGenres();
    //     }, [setSelectedOption])

    //     useEffect(() => {
    //         async function fetchByID({
    //             genres.map((genre) => (

    //         const request2 = await axios.get(`/discover/movie?api_key=${API_KEY}&with_genres=${genre.id}`);
    //         console.log(request2);
    //         setbyIDs(requests.data.genres.id);
    //         return request2;
    //         ))
    //     fetchByID();


    // })
    //     }, [])


    return (
        <div className="nav">

            {/* <h3 onClick={() => setSelectedOption(requests.fetchTrending)}>Trending</h3> */}
            <h3 onClick={() => setSelectedOption(requests.fetchPopular)}>Popular</h3>

            <h3 onClick={() => setSelectedOption(requests.fetchActionMovies)}>Action</h3>
            <h3 onClick={() => setSelectedOption(requests.fetchAdventureMovies)}>Adventure</h3>
            <h3 onClick={() => setSelectedOption(requests.fetchAnimation)}>Animation</h3>
            <h3 onClick={() => setSelectedOption(requests.fetchComedyMovies)}>Comedy</h3>
            <h3 onClick={() => setSelectedOption(requests.fetchCrimeMovies)}>Crime</h3>
            <h3 onClick={() => setSelectedOption(requests.fetchDocuMovies)}>Documentary</h3>
            <h3 onClick={() => setSelectedOption(requests.fetchDramaMovies)}>Drama</h3> >
            <h3 onClick={() => setSelectedOption(requests.fetchFamilyMovies)}>Family</h3>
            <h3 onClick={() => setSelectedOption(requests.fetchHistoryMovies)}>History</h3>
            <h3 onClick={() => setSelectedOption(requests.fetchHorrorMovies)}>Horror</h3>
            <h3 onClick={() => setSelectedOption(requests.fetchMusicMovies)}>Music</h3>
            <h3 onClick={() => setSelectedOption(requests.fetchMystery)}>Mystery</h3>
            <h3 onClick={() => setSelectedOption(requests.fetchRomanceMovies)}>Romance</h3>
            <h3 onClick={() => setSelectedOption(requests.fetchSciFi)}>SciFi</h3>
            <h3 onClick={() => setSelectedOption(requests.fetchThrilerMovies)}>Thriller</h3>
            <h3 onClick={() => setSelectedOption(requests.fetchWarMovies)}>War</h3>

            {/* <h3 onClick={() => setSelectedOption(requests.fetchTrendingMovie)}>Movie</h3>
            <h3 onClick={() => setSelectedOption(requests.fetchTrendingTV)}>TVShows</h3>
            <h3 onClick={() => setSelectedOption(requests.fetchTopRated)}>Top Rated</h3> */}

            <h3 onClick={() => setSelectedOption(requests.fetchHulu)}>HULU</h3>
            <h3 onClick={() => setSelectedOption(requests.fetchNetflixOriginals)}>NETFLIX</h3>
            <h3 onClick={() => setSelectedOption(requests.fetchCBS)}>CBS</h3>
            <h3 onClick={() => setSelectedOption(requests.fetchABC)}>ABC</h3>
            <h3 onClick={() => setSelectedOption(requests.fetchFOX)}>FOX</h3>
            <h3 onClick={() => setSelectedOption(requests.fetchUSANet)}>USA</h3>
            <h3 onClick={() => setSelectedOption(requests.fetchMTV)}>MTV</h3>
            <h3 onClick={() => setSelectedOption(requests.fetchHBO)}>HBO</h3>
            <h3 onClick={() => setSelectedOption(requests.fetchDisney)}>DISNEY</h3>
            <h3 onClick={() => setSelectedOption(requests.fetchHistory)}>HISTORY</h3>
            <h3 onClick={() => setSelectedOption(requests.fetchAmazon)}>AMAZON</h3>
            <h3 onClick={() => setSelectedOption(requests.fetchYoutubeOrg)}>YOUTUBE</h3>
            <h3 onClick={() => setSelectedOption(requests.fetchSyFy)}>SYFY</h3>





        </div >
    )
}

export default Nav
